<template>
  <div
    :class="{
      'close': true,
      'close_plus': plus,
      'close_add': add
    }"
    @click.stop="$emit('delete')"
  >
  </div>
</template>

<script>

export default {
  name: 'DeleteCategoryIcon',
  components: {
  },
  props: {
    plus: {
      type: Boolean,
      default: false
    },
    add: {
      type: Boolean,
      default: false
    }
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>
.close {
  position: relative;
  width: 20px;
  height: 20px;
  cursor: pointer;

  &::before, &::after {
    content: "";
    position: absolute;
    width: 12px;
    height: 2px;
    background-color: #000000;
    border-radius: 2px;
    top: 9px;
    right: 3px;
  }

  &:hover {
    &::before, &::after {
      background-color: #00ABEC;
    }
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }

  &_plus {
    &:hover {
      &::before, &::after {
        background-color: #FFFFFF;
      }
    }
    &::before, &::after {
      background-color: #FFFFFF;
    }
    &::before {
      transform: rotate(90deg);
    }

    &::after {
      transform: rotate(180deg);
    }
  }
  &_add {
    &:hover {
      &::before, &::after {
        background-color: #00ABEC;
      }
    }
    &::before, &::after {
      background-color: #000000;
    }

    &::before {
      transform: rotate(90deg);
    }

    &::after {
      transform: rotate(180deg);
    }
  }
}

</style>
